var _circle, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMountains = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 120 120"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 60,
  r: 60,
  fill: "#F6F9FC"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mountains_svg__a",
  width: 112,
  height: 120,
  x: 4,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C6365B",
  d: "M115.776 63.986c0 30.723-24.947 55.629-55.72 55.629-30.775 0-55.722-24.906-55.722-55.63C4.334 36.196 26.141.5 59.781.5c7.906 0 14.707 0 16.716 1.187 19.963 10.738 39.279 39.374 39.279 62.299Z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mountains_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#C0D8F0",
  d: "M39.994 48.412 52.35 28.115l12.355 20.297-8.384-2.647-3.971 2.647-5.295-2.647-7.06 2.647ZM73.18 64.286l9.44-18.092 9.44 18.44h-4.412l-5.028 3.698-5.306-3.697-4.134-.35Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEEEF1",
  d: "M72.204 6.274H52.789v15.444h21.62l-8.824-8.384 6.619-7.06Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.827,
  d: "M73.353 63.856 52.238 27.013l-41.587 71.48h98.617L82.573 45.986l-21.4 41.476"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.827,
  d: "m39.773 48.743 7.28-2.978 5.296 2.978 4.633-2.978 7.721 2.978m8.163 15.995h4.523l5.074 3.64 4.854-3.64h4.743M52.349 27.013v-4.854m0 0V6.164h20.958l-7.942 7.832 7.942 8.163H52.35Z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.868,
  height: 2.868,
  x: 50.804,
  y: 54.148,
  fill: "#36485C",
  rx: 0.365
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.868,
  height: 2.868,
  x: 50.804,
  y: 59.885,
  fill: "#36485C",
  rx: 0.365
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.868,
  height: 2.868,
  x: 50.804,
  y: 65.621,
  fill: "#36485C",
  rx: 0.365
}))));
export default SvgMountains;